export default {
  'HELP_PAGE_CONTENT': 'Help Center Page',
  'BACK_TO_ALERTS': 'Back to alerts',
  'ALERT_TABLE_HEAD_ALERT': 'Alert',
  'ALERT_TABLE_HEAD_START_TIME': 'Start date & time',
  'ALERT_TABLE_CELL_ALERT': '{event_type} at {intersection_name}',
  'ALERT_TABLE_CELL_START_TIME': '{start_time}',
  'ALERT_TABLE_CELL_OPEN_ON_MAP': 'Open on map',
  'BUSINESS_RULES_ROUTES_TAB': 'Routes',
  'BUSINESS_RULES_PRIORITY_RULES_TAB': 'Priority Rules',
  'BUSINESS_RULES_ROUTES_TABLE_HEAD_LAST_SAVED': 'Last saved',
  'BUSINESS_RULES_ROUTES_TABLE_HEAD_STATUS': 'Status',
  'BUSINESS_RULES_ROUTES_TABLE_CELL_EDIT_RULES': 'Edit rules',
  'BUSINESS_RULES_ROUTES_SEARCH_PLACEHOLDER': 'Search routes',
  'USERS_AND_PERMISSIONS_USERS_TAB': 'Users',
  'USERS_AND_PERMISSIONS_ROLES_TAB': 'Roles',
  'USERS_AND_PERMISSIONS_REQUESTS_TAB': 'Requests',
  'USERS_AND_PERMISSIONS_USERS_TABLE_TITLE': 'Manage or invite users',
  'INVITE_NEW_USER': 'Invite new user',
  'U_AND_P_TABLE_HEADER_EMAIL': 'Email',
  'U_AND_P_TABLE_HEADER_REGISTER_DATE': 'Register Date',
  'U_AND_P_TABLE_HEADER_ROLE': 'Role',
  'U_AND_P_TABLE_HEADER_APPROVED_AGENCIES': 'Approved Agencies',
  'U_AND_P_ADD_AGENCY': 'Add agency',
  'U_AND_P_NO_ADDITIONAL_CHOICES': 'No Additional Choices',
  'MULTI_SELECT_PLACEHOLDER': 'Select items',
  'LOGOUT': 'Logout',
  'SELECT_INTERSECTION': 'Select intersection',
  'BACK_TO_WEBSITE': 'Back to website',
  'PAGE_NOT_FOUND': 'Page not found',
  'PAGE_NOT_FOUND_DESCRIPTION': 'The page you were looking for could not be found',
  'MAP_SEARCH': 'Search for an agency',
  'LIVE_MAP.EVP_SEARCH_PLACEHOLDER': 'Find a vehicle, event, or intersection.',
  'LIVE_MAP.TRANSIT_SEARCH_PLACEHOLDER_LYT21': 'Find a bus or intersection',
  'ROUTES_NAV_TSP_STATISTICS': 'TSP Statistics',
  'ROUTES_NAV_PERFORMANCE': 'Performance',
  'SYSTEM_HEALTH_SIGNAL_NETWORK_TAB': 'Signal Network',
  'SYSTEM_HEALTH_TRANSIT_VEHICLE_TAB': 'Transit Vehicle CAD/AVL',
  'SYSTEM_HEALTH_TSP_HEALTH_TAB': 'TSP Health',
  'SYSTEM_HEALTH_ALERTS_TAB': 'Alerts',
  'SYSTEM_HEALTH_METRICS_GROUP': 'Health metrics',
  'SYSTEM_HEALTH_OPERATIONS_GROUP': 'Operational awareness',
  'TEAM_ACTIVE_USERS_TAB': 'Active Users',
  'TEAM_USER_LOGIN_HISTORY_TAB': 'User Login History',
  'TEAM_REQUESTS_TAB': 'Requests',
  'DASHBOARD.CHART.TOTAL_TSP_CALLS_PER_HOUR.TITLE': 'Average TSP Calls Per Hour',
  'DASHBOARD.CHART.TOTAL_TSP_CALLS_PER_HOUR.CSV_Y': 'Average TSP Calls per Hour',
  'DASHBOARD.CHART.TOTAL_TSP_CALLS_PER_HOUR.CSV_HOUR': 'Hour',
  'TEAM.MODAL.EDIT_ROLE.AGENCY_OWNER_USE_TRANSFER_OWNERSHIP': 'To assign agency ownership, use the Transfer Ownership action on the current Agency Owner row.',
  'TRIP_ANALYZER.PAGE_TITLE': 'Trip Analyzer',
  'TRIP_ANALYZER.QUERY.SERVICE_DATE_LABEL': 'Service date',
  'TRIP_ANALYZER.QUERY.ROUTE_LABEL': 'Route',
  'TRIP_ANALYZER.QUERY.DIRECTION_LABEL': 'Direction',
  'TRIP_ANALYZER.QUERY.TRIP_LABEL': 'Trip',
  'TRIP_ANALYZER.QUERY.PARTNER_LABEL': 'Jurisdiction',
  'TRIP_ANALYZER.QUERY.SELECT_ROUTE_PLACEHOLDER': 'Select a route',
  'TRIP_ANALYZER.QUERY.ROUTES_LOAD_ERROR': 'Couldn’t load routes',
  'TRIP_ANALYZER.QUERY.DIRECTIONS_LOAD_ERROR': 'Couldn’t load directions',
  'TRIP_ANALYZER.QUERY.TRIPS_LOAD_ERROR': 'Couldn’t load trips',
  'TRIP_ANALYZER.QUERY.CATALOG_LOAD_ERROR_DETAIL': 'Refresh the page to try again.',
  'TRIP_ANALYZER.QUERY.REFRESH_PAGE': 'Refresh page',
  'TRIP_ANALYZER.QUERY.SELECT_DIRECTION_PLACEHOLDER': 'Select a direction',
  'TRIP_ANALYZER.QUERY.SELECT_TRIP_PLACEHOLDER': 'Select a trip',
  'TRIP_ANALYZER.QUERY.SELECT_PARTNER_PLACEHOLDER': 'All jurisdictions',
  'TRIP_ANALYZER.TIMELINE.TABLE_CONTROLS_LABEL': 'Table controls',
  'TRIP_ANALYZER.TIMELINE.TABLE_LEGEND_LABEL': 'Table legend',
  'TRIP_ANALYZER.TIMELINE.TABLE_VIEW_OPTIONS_LABEL': 'Table view options',
  'TRIP_ANALYZER.QUERY.ON_TIME_WINDOW_LABEL': 'On-time window',
  'TRIP_ANALYZER.QUERY.ON_TIME_WINDOW_HINT': 'Schedule deviation inside this range is colored as on time in the timeline.',
  'TRIP_ANALYZER.QUERY.SELECT_DATE_PLACEHOLDER': 'Select date',
  'TRIP_ANALYZER.QUERY.TIME_WINDOW_ALL_DAY_LABEL': 'All day',
  'TRIP_ANALYZER.QUERY.TIME_WINDOW_START_LABEL': 'From',
  'TRIP_ANALYZER.QUERY.TIME_WINDOW_END_LABEL': 'Until',
  'TRIP_ANALYZER.QUERY.TIME_WINDOW_CLEAR_ACTION': 'Clear',
  'TRIP_ANALYZER.QUERY.TRIP_SET_ADD_TRIP_ACTION': 'Add to trip set',
  'TRIP_ANALYZER.QUERY.TRIP_SET_ADD_TRIPS_ACTION': 'Add {count} trips to set',
  'TRIP_ANALYZER.QUERY.TRIP_SET_ADD_ALL_TRIPS_ACTION': 'Add all {count} trips to set',
  'TRIP_ANALYZER.QUERY.TRIP_SET_CLEAR_ACTION': 'Clear set',
  'TRIP_ANALYZER.QUERY.TRIP_SET_ADD_TRIP_DISABLED': 'Select trips to add',
  'TRIP_ANALYZER.QUERY.TRIP_SET_VISIBILITY_LABEL': 'Filter visible trips',
  'TRIP_ANALYZER.QUERY.TRIP_SET_VISIBILITY_HINT': 'Choose which trips in the set appear in the table. Hidden trips stay in your trip set.',
  'TRIP_ANALYZER.QUERY.TRIP_SET_VISIBILITY_PLACEHOLDER': 'Select trips to show',
  'TRIP_ANALYZER.QUERY.TRIP_SET_VISIBILITY_TRIGGER_SINGULAR': '1 trip',
  'TRIP_ANALYZER.QUERY.TRIP_SET_VISIBILITY_TRIGGER_PLURAL': '{count} trips',
  'TRIP_ANALYZER.QUERY.TRIP_SET_REMOVE_TRIP_ACTION': 'Remove from trip set',
  'TRIP_ANALYZER.QUERY.TRIP_SET_ALREADY_IN_SET': 'Already in trip set',
  'TRIP_ANALYZER.QUERY.TRIP_SET_STAGING_BADGE': 'Preview',
  'TRIP_ANALYZER.QUERY.TRIP_SET_STAGING_NOTE': 'Search results — not in your trip set yet. Add the ones you want to keep.',
  'TRIP_ANALYZER.QUERY.TRIP_SET_CHIPS_LABEL': 'Trip set',
  'TRIP_ANALYZER.QUERY.TRIP_SET_COUNT_SINGULAR': '1 trip in set',
  'TRIP_ANALYZER.QUERY.TRIP_SET_COUNT_PLURAL': '{count} trips in set',
  'TRIP_ANALYZER.QUERY.TRIP_SET_SHOW_TRIP_ACTION': 'Show in timeline',
  'TRIP_ANALYZER.QUERY.TRIP_SET_CHIPS_HELPER': 'Click a chip to show its trip in the timeline, or × to remove it from the set.',
  'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_INLINE': 'No trips in the set yet. Search above, review the results, then add them.',
  'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_STEP_CORRIDOR': 'Route & direction',
  'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_STEP_FIRST_TRIP': 'Add trips',
  'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_STEP_MORE_TRIPS': 'Add more dates',
  'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_TITLE_START': 'Build a trip set',
  'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_TITLE_CORRIDOR': 'Choose a route and direction',
  'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_TITLE_ADD_TRIP': 'Search and add trips',
  'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_TITLE_MORE_TRIPS': 'Add trips on other dates',
  'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_DETAIL_START': 'Collect trips from any dates on the same route and direction.',
  'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_DETAIL_CORRIDOR': 'Pick a date, route, and direction. Every trip that day appears here to review and add to your trip set.',
  'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_DETAIL_ADD_TRIP': 'Pick trips in Find trips, review the results, then add them to your trip set.',
  'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_DETAIL_MORE_TRIPS': 'Change the date to add trips from other days to your trip set.',
  'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_TITLE': 'No trips in your trip set',
  'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_DETAIL': 'Use Find trips above to search, review the results here, then add them.',
  'TRIP_ANALYZER.QUERY.TRIP_SET_ALL_HIDDEN_TITLE': 'All trips in the set are hidden',
  'TRIP_ANALYZER.QUERY.TRIP_SET_ALL_HIDDEN_DETAIL': 'Open table controls and use Filter visible trips to show rows again.',
  'TRIP_ANALYZER.QUERY.TRIP_SET_CORRIDOR_LOCK_TOOLTIP': 'A trip set stays on one route and direction',
  'TRIP_ANALYZER.ERRORS.PERMISSION_DENIED': 'You do not have permission to view Trip Analyzer data for this agency.',
  'TRIP_ANALYZER.ERRORS.NO_TRIP_HISTORY': 'No observed trip history is available for this agency yet.',
  'TRIP_ANALYZER.TIMELINE.NO_TRIPS_IN_TIME_WINDOW_TITLE': 'No trips in this time window',
  'TRIP_ANALYZER.TIMELINE.NO_TRIPS_IN_TIME_WINDOW_DETAIL': 'No trips depart within the selected time window. Try widening the range or clearing it.',
  'TRIP_ANALYZER.QUERY.TRIP_CATALOG_ALL_TRIPS_SUBTEXT': '{count} trips',
  'SIDEBAR.AGENCY_SELECTOR.LABEL': 'Agency: {agency}',
  'TRIP_ANALYZER.TRIP.VEHICLE': 'Vehicle {vehicle}',
  'TRIP_ANALYZER.TIMELINE.OFF_CORRIDOR_CELL': 'Not on this trip\'s corridor on its service date',
  'TRIP_ANALYZER.TIMELINE.LEGEND_OFF_CORRIDOR': 'Not on corridor',
  'TRIP_ANALYZER.TSP.PANEL_TITLE': 'TSP Event Log',
  'TRIP_ANALYZER.TSP.PANEL_CLOSE': 'Close TSP event log',
  'TRIP_ANALYZER.TSP.PANEL_NO_TSP': 'No TSP requests at this signal on this trip.',
  'TRIP_ANALYZER.FOCUS.MORE_TRIPS_SINGULAR': '1 more trip',
  'TRIP_ANALYZER.FOCUS.MORE_TRIPS_PLURAL': '{count} more trips',
  'TRIP_ANALYZER.FOCUS.MORE_SIGNALS_SINGULAR': '1 more signal',
  'TRIP_ANALYZER.FOCUS.MORE_SIGNALS_PLURAL': '{count} more signals',
  'TRIP_ANALYZER.FOCUS.PREVIOUS_TRIP': 'Previous trip',
  'TRIP_ANALYZER.FOCUS.NEXT_TRIP': 'Next trip',
  'TRIP_ANALYZER.FOCUS.PREVIOUS_SIGNAL': 'Previous signal',
  'TRIP_ANALYZER.FOCUS.NEXT_SIGNAL': 'Next signal',
  'TRIP_ANALYZER.TSP.PANEL_NAV_HINT': '← → signals · ↑ ↓ trips · Esc to close',
  'TRIP_ANALYZER.TSP.PANEL_NO_ARRIVAL': 'No signal arrival recorded at this signal on this trip.',
  'TRIP_ANALYZER.TSP.PANEL_LOADING': 'Loading TSP activity…',
  'TRIP_ANALYZER.TSP.PANEL_EMPTY': 'No TSP activity recorded at this signal',
  'TRIP_ANALYZER.TSP.EVENTS_LOAD_ERROR': 'Unable to load TSP events.',
  'TRIP_ANALYZER.TSP.PANEL_RETRY': 'Retry',
  'TRIP_ANALYZER.TSP.PANEL_ARRIVAL': 'Arrival {time}',
  'TRIP_ANALYZER.TSP.PANEL_SET_LETTER': 'Trip {side}',
  'TRIP_ANALYZER.TSP.PAGER_PREVIOUS': 'Previous session',
  'TRIP_ANALYZER.TSP.PAGER_NEXT': 'Next session',
  'TRIP_ANALYZER.TSP.PAGER_POSITION': 'Session {current} of {total}',
  'TRIP_ANALYZER.TSP.SESSION_REQUEST_TAG': 'Request tag',
  'TRIP_ANALYZER.TSP.SESSION_COMMAND_SET': 'Controller',
  'TRIP_ANALYZER.TSP.SESSION_CHANNEL': 'Channel',
  'TRIP_ANALYZER.TSP.SESSION_SIGNAL': 'Signal',
  'TRIP_ANALYZER.TSP.COLUMN_REQUEST_SENT': 'Local request sent',
  'TRIP_ANALYZER.TSP.COLUMN_STATUS_RECEIVED': 'Status received',
  'TRIP_ANALYZER.TSP.COLUMN_COMMAND': 'Command name',
  'TRIP_ANALYZER.TSP.COLUMN_REQUEST': 'Request',
  'TRIP_ANALYZER.TSP.COLUMN_STATUS': 'Status',
  'TRIP_ANALYZER.TSP.STATUS_TIME_UNAVAILABLE': 'No status received',
  'TRIP_ANALYZER.TSP.SHOW_RAW': 'Show raw',
  'TRIP_ANALYZER.TSP.HIDE_RAW': 'Hide raw',
  'TRIP_ANALYZER.TSP.RAW_FALLBACK': 'Raw',
  'TRIP_ANALYZER.TSP.RAW_FALLBACK_TOOLTIP': 'This command set or payload is not recognized, so the original payload is shown.',
  'TRIP_ANALYZER.TSP.TIMEZONE_NOTE': 'Times are agency local, as recorded by the controller.',
  'TRIP_ANALYZER.TIMELINE.OUTSIDE_JURISDICTION': 'Outside selected jurisdiction',
  'TRIP_ANALYZER.TIMELINE.RESTRICTED_JURISDICTION': 'Not in your assigned jurisdictions',
  'TRIP_ANALYZER.TIMELINE.RESTRICTED_OVERLAY': 'Restricted',
  'TRIP_ANALYZER.TSP.CHIP_VEHICLE': 'Vehicle',
  'TRIP_ANALYZER.TSP.CHIP_VEHICLE_TOOLTIP': 'Transit vehicle ID for the trip being analyzed.',
  'TRIP_ANALYZER.TSP.CHIP_AVL_PING': 'AVL ping',
  'TRIP_ANALYZER.TSP.CHIP_AVL_PING_TOOLTIP': 'Time of the nearest AVL location update used for context at this signal.',
  'TRIP_ANALYZER.TSP.CHIP_SCHEDULE_DEVIATION': 'Schedule deviation',
  'TRIP_ANALYZER.TSP.CHIP_SCHEDULE_DEVIATION_TOOLTIP': 'How far ahead (+) or behind (−) schedule the vehicle was at this signal, based on the nearest AVL ping before TSP check-in.',
  'TRIP_ANALYZER.TSP.CHIP_SCHEDULE_DEVIATION_VALUE': '{seconds} s',
  'TRIP_ANALYZER.TSP.CHIP_SCHEDULE_DEVIATION_AGE': '({age}s before)',
  'TRIP_ANALYZER.TSP.CHIP_CONTROLLER_TOOLTIP': 'Traffic signal controller type (e.g. OMNI, NTCIP1211). Determines how request and status payloads are interpreted.',
  'TRIP_ANALYZER.TSP.CHIP_REQUEST_TAG_TOOLTIP': 'Identifier the controller assigned to this TSP session. Events sharing a request tag belong to the same check-in.',
  'TRIP_ANALYZER.TSP.VALUE_UNAVAILABLE': '—',
  'TRIP_ANALYZER.TIMELINE.REGION_LABEL': 'Trip timeline',
  'TRIP_ANALYZER.TIMELINE.KEYBOARD_HINT': 'Use the arrow keys to move between signals. Home and End jump to the first or last signal of a trip. Press Enter on a signal with TSP activity to open its event log.',
  'TRIP_ANALYZER.TIMELINE.NO_ARRIVAL': 'No signal arrival recorded for this trip',
  'TRIP_ANALYZER.TIMELINE.TRIP_ARRIVALS_DETAIL': '{arrivals} of {total} corridor signals have a recorded arrival for this trip',
  'TRIP_ANALYZER.TIMELINE.COLUMN_GREEN_DETAIL': '{green} of {arrivals} trips shown arrived on green at {signal}',
  'TRIP_ANALYZER.TIMELINE.REORDER_HANDLE': 'Reorder {trip}',
  'TRIP_ANALYZER.TIMELINE.REORDER_HINT': 'Drag, or press Space, to reorder',
  'TRIP_ANALYZER.TIMELINE.REORDER_INSTRUCTIONS': 'To reorder a trip, press Space or Enter on its handle, use the up and down arrow keys to move it, then press Space or Enter to drop it. Press Escape to cancel.',
  'TRIP_ANALYZER.TIMELINE.REORDER_PICKED_UP': 'Picked up {trip}. Position {position} of {total}.',
  'TRIP_ANALYZER.TIMELINE.REORDER_MOVED': '{trip} moved to position {position} of {total}.',
  'TRIP_ANALYZER.TIMELINE.REORDER_DROPPED': '{trip} dropped at position {position} of {total}.',
  'TRIP_ANALYZER.TIMELINE.REORDER_CANCELLED': 'Reorder cancelled. {trip} returned to position {position} of {total}.',
  'TRIP_ANALYZER.TIMELINE.KEYBOARD_HINT_SHORT': 'Arrow keys move between signals',
  'TRIP_ANALYZER.TIMELINE.SKIPPED_COLUMNS': 'Skipped {columns}',
  'TRIP_ANALYZER.TIMELINE.LOADING_TITLE': 'Loading trip timeline',
  'TRIP_ANALYZER.TIMELINE.READY_TITLE': 'Timeline ready',
  'TRIP_ANALYZER.TIMELINE.LOADING_CORRIDORS': 'Loading trip corridors…',
  'TRIP_ANALYZER.TIMELINE.LOADING_ALIGNING': 'Aligning intersection columns…',
  'TRIP_ANALYZER.TIMELINE.LOADING_ALMOST': 'Almost ready…',
  'TRIP_TRACER.PAGE_TITLE': 'Trip Tracer',
  'TRIP_TRACER.QUERY_BAR_LABEL': 'Trip Tracer query',
  'TRIP_TRACER.SERVICE_DATE_LABEL': 'Service date',
  'TRIP_TRACER.SELECT_DATE_PLACEHOLDER': 'Select date',
  'TRIP_TRACER.VEHICLE_LABEL': 'Vehicle',
  'TRIP_TRACER.SELECT_VEHICLE_PLACEHOLDER': 'Select vehicle',
  'TRIP_TRACER.SEARCH_VEHICLES_PLACEHOLDER': 'Search vehicles',
  'TRIP_TRACER.TIMEZONE_NOTE': 'Times in {timezone}',
  'TRIP_TRACER.AGENCY_LOADING': 'Checking Trip Tracer availability for this agency…',
  'TRIP_TRACER.AGENCY_UNAVAILABLE': 'Trip Tracer is not available for this agency.',
  'TRIP_TRACER.PARTIAL_COVERAGE_WARNING': 'AVL coverage for this agency is partial. Some dates or vehicles may be missing.',
  'TRIP_TRACER.AGENCY_LOAD_ERROR': 'Trip Tracer could not check this agency. Try again later.',
  'TRIP_TRACER.AVL_DATES_LOAD_ERROR': 'Available dates could not be loaded.',
  'TRIP_TRACER.NO_AVL_DATES_IN_MONTH': 'No AVL data in this month.',
  'TRIP_TRACER.VEHICLES_LOAD_ERROR': 'Vehicles could not be loaded.',
  'TRIP_TRACER.ROUTES_LOAD_ERROR': 'Routes could not be loaded.',
  'TRIP_TRACER.MODE_LABEL': 'Replay',
  'TRIP_TRACER.MODE_VEHICLE': 'Vehicle',
  'TRIP_TRACER.MODE_ROUTE': 'Route',
  'TRIP_TRACER.ROUTE_LABEL': 'Route',
  'TRIP_TRACER.SELECT_ROUTE_PLACEHOLDER': 'Select route',
  'TRIP_TRACER.SEARCH_ROUTES_PLACEHOLDER': 'Search routes',
  'TRIP_TRACER.NO_ROUTES_ON_DATE': 'No routes reported AVL on this date.',
  'TRIP_TRACER.NO_VEHICLES_ON_DATE': 'No vehicles reported AVL on this date.',
  'TRIP_TRACER.TIME_WINDOW_ALL_DAY_LABEL': 'All day',
  'TRIP_TRACER.TIME_WINDOW_START_LABEL': 'From',
  'TRIP_TRACER.TIME_WINDOW_END_LABEL': 'Until',
  'TRIP_TRACER.TIME_WINDOW_CLEAR_ACTION': 'Clear',
  'TRIP_TRACER.TIME_LABEL_WITH_ZONE': '{label} ({timezone})',
  'TRIP_TRACER.TIME_WINDOW_INCOMPLETE': 'Choose both a start and an end time, or turn on All day.',
  'TRIP_TRACER.TIME_WINDOW_ORDER': 'The start time must be earlier than the end time. A window can’t cross midnight.',
  'TRIP_TRACER.TIME_WINDOW_FORMAT': 'Enter times as HH:MM.',
  'TRIP_TRACER.AVL_DATES_LOADING': 'Loading available dates…',
  'TRIP_TRACER.REPLAY_LOADING': 'Loading vehicle history…',
  'TRIP_TRACER.REPLAY_CAPPED': 'This replay hit the point limit, so later records are missing. Narrow the time window to see them all.',
  'TRIP_TRACER.REPLAY_SAMPLE_COARSENED': 'Sampled every {effective} s instead of {requested} s to fit the point limit.',
  'TRIP_TRACER.REPLAY_LOAD_ERROR': 'Vehicle history could not be loaded.',
  'TRIP_TRACER.MAP_LABEL': 'Vehicle path map',
  'TRIP_TRACER.MAP_ZOOM_IN': 'Zoom in',
  'TRIP_TRACER.MAP_ZOOM_OUT': 'Zoom out',
  'TRIP_TRACER.MAP_FIT_TO_RESULT': 'Fit to vehicle path',
  'TRIP_TRACER.MAP_UNAVAILABLE': 'The map could not be loaded.',
  'TRIP_TRACER.PLAYBACK_LABEL': 'Playback',
  'TRIP_TRACER.PLAYBACK_PLAY': 'Play',
  'TRIP_TRACER.PLAYBACK_PAUSE': 'Pause',
  'TRIP_TRACER.PLAYBACK_STOP': 'Stop',
  'TRIP_TRACER.PLAYBACK_TIMELINE': 'Timeline',
  'TRIP_TRACER.PLAYBACK_SPEED': 'Playback speed',
  'TRIP_TRACER.PLAYBACK_SPEED_OPTION': '{speed}×',
  'TRIP_TRACER.PLAYBACK_FRAME_COUNT': 'Frame {frame} of {total}',
  'TRIP_TRACER.RECORDS_TITLE': 'AVL records',
  'TRIP_TRACER.RECORDS_COUNT': '{count} records',
  'TRIP_TRACER.RECORDS_EMPTY': 'No records for the visible vehicles.',
  'TRIP_TRACER.RECORDS_NAV_HINT': 'Select a row to jump the map and playback to that record.',
  'TRIP_TRACER.RECORDS_COLUMN_TIME': 'Time',
  'TRIP_TRACER.RECORDS_COLUMN_VEHICLE': 'Vehicle',
  'TRIP_TRACER.RECORDS_COLUMN_LATITUDE': 'Latitude',
  'TRIP_TRACER.RECORDS_COLUMN_LONGITUDE': 'Longitude',
  'TRIP_TRACER.RECORDS_COLUMN_COORDINATES': 'Coordinates',
  'TRIP_TRACER.RECORDS_COLUMN_SPEED': 'Speed (mph)',
  'TRIP_TRACER.RECORDS_COLUMN_BEARING': 'Heading (°)',
  'TRIP_TRACER.RECORDS_COLUMN_DEVIATION': 'Deviation (s)',
  'TRIP_TRACER.RECORDS_COLUMN_ROUTE': 'Route',
  'TRIP_TRACER.RECORDS_COLUMN_TRIP': 'Trip',
  'TRIP_TRACER.VEHICLES_TITLE': 'Vehicles',
  'TRIP_TRACER.VEHICLES_SHOWN': '{shown} of {total} shown',
  'TRIP_TRACER.VEHICLES_ALL': 'All',
  'TRIP_TRACER.VEHICLES_NONE': 'None',
  'TRIP_TRACER.VEHICLES_POINTS': '{count} points',
  'TRIP_TRACER.VEHICLES_ACTIVE_SPAN': 'Reporting {start} – {end}',
  'TRIP_TRACER.VEHICLES_NO_TRIP': 'No trip ID',
  'TRIP_TRACER.VEHICLES_MORE_TRIPS': '{first} +{count}',
  'TRIP_TRACER.VEHICLES_TOGGLE_HINT': 'Click to follow on the map. The eye shows or hides it on the map, playback, and records.',
  'TRIP_TRACER.VEHICLE_HIDE': 'Hide vehicle {vehicle}',
  'TRIP_TRACER.VEHICLE_SHOW': 'Show vehicle {vehicle}',
  'TRIP_TRACER.MAP_LAYERS_LABEL': 'Map layers',
  'TRIP_TRACER.LAYERS_SECTION_PATH': 'Path display',
  'TRIP_TRACER.LAYERS_SECTION_OVERLAYS': 'Layers',
  'TRIP_TRACER.MAP_LAYERS_CLOSE': 'Close map layers',
  'TRIP_TRACER.LAYER_PROGRESSIVE': 'Progressive path',
  'TRIP_TRACER.LAYER_ROUTE_SHAPE': 'Route shape',
  'TRIP_TRACER.LAYER_STOPS': 'Bus stops',
  'TRIP_TRACER.COLOR_PATH_BY': 'Color path by',
  'TRIP_TRACER.COLOR_BY_VEHICLE': 'Vehicle',
  'TRIP_TRACER.COLOR_BY_SPEED': 'Speed',
  'TRIP_TRACER.SPEED_KEY_TITLE': 'Speed (mph)',
  'TRIP_TRACER.SPEED_NONE': 'No speed',
  'TRIP_TRACER.SPEED_BELOW_VALUE': '< {mph}',
  'TRIP_TRACER.SPEED_RANGE_VALUE': '{from}–{to}',
  'TRIP_TRACER.SPEED_ABOVE_VALUE': '{mph}+',
  'TRIP_TRACER.SPEED_THRESHOLDS_LABEL': 'Thresholds',
  'TRIP_TRACER.SPEED_MODERATE_FROM': 'Moderate',
  'TRIP_TRACER.SPEED_FAST_FROM': 'Fast',
  'TRIP_TRACER.SPEED_MODERATE_FROM_ARIA': 'Moderate speed starts at, in mph',
  'TRIP_TRACER.SPEED_FAST_FROM_ARIA': 'Fast speed starts at, in mph',
  'TRIP_TRACER.SPEED_MODERATE_THUMB': 'Moderate speed threshold',
  'TRIP_TRACER.SPEED_FAST_THUMB': 'Fast speed threshold',
  'TRIP_TRACER.SPEED_EDIT': 'Edit speed thresholds',
  'TRIP_TRACER.SPEED_HIGH': 'Fast',
  'TRIP_TRACER.SPEED_MID': 'Moderate',
  'TRIP_TRACER.SPEED_LOW': 'Slow',
  'TRIP_TRACER.SPEED_RESET': 'Reset',
  'TRIP_TRACER.STOPS_NO_ROUTES': 'Bus stops need a route in the loaded data.',
  'TRIP_TRACER.STOPS_UNAVAILABLE': 'Bus stops are not available for this agency.',
  'TRIP_TRACER.STOPS_LOAD_ERROR': 'Bus stops could not be loaded.',
  'TRIP_TRACER.STOPS_TRUNCATED': 'Showing the first stops only.',
  'TRIP_TRACER.MAP_SATELLITE': 'Satellite view',
  'TRIP_TRACER.MAP_DEFAULT_VIEW': 'Default view',
  'TRIP_TRACER.TRACK_VEHICLE': 'Follow vehicle',
  'TRIP_TRACER.PICK_VEHICLE_TO_FOLLOW': 'Click a vehicle on the map to follow it',
  'TRIP_TRACER.STOP_TRACKING': 'Stop following',
  'TRIP_TRACER.STOP_POPUP_ID': 'Stop ID',
  'TRIP_TRACER.RECORDS_COLUMNS': 'Columns',
  'TRIP_TRACER.RECORDS_SHOW_ALL_COLUMNS': 'Show all columns',
  'TRIP_TRACER.POPUP_VEHICLE': 'Vehicle {vehicleId}',
  'TRIP_TRACER.POPUP_TIME': 'Time',
  'TRIP_TRACER.POPUP_SPEED': 'Speed',
  'TRIP_TRACER.POPUP_SPEED_VALUE': '{speed} mph',
  'TRIP_TRACER.POPUP_HEADING': 'Heading',
  'TRIP_TRACER.POPUP_HEADING_VALUE': '{heading}°',
  'TRIP_TRACER.POPUP_DEVIATION': 'Schedule deviation',
  'TRIP_TRACER.POPUP_DEVIATION_VALUE': '{seconds} s',
  'TRIP_TRACER.POPUP_ROUTE': 'Route',
  'TRIP_TRACER.POPUP_NOT_REPORTED': 'Not reported',
  'TRIP_TRACER.POPUP_CLOSE': 'Close details',

  // Deep links
  'DEEP_LINKS.ANALYZE_IN_TRIP_ANALYZER': 'Yesterday’s trips',
  'DEEP_LINKS.TRIP_ANALYZER.DATE_NO_DATA': 'No trips on {date}. Pick another date.',
  'DEEP_LINKS.TRIP_ANALYZER.DATE_NOT_YET_AVAILABLE': 'No trips for {date} yet. Showing {fallback}.',
  'DEEP_LINKS.TRIP_ANALYZER.ROUTE_NOT_FOUND': 'Route {value} has no trips on {date}.',
  'DEEP_LINKS.TRIP_ANALYZER.VEHICLE_NOT_FOUND': 'Vehicle {value} has no trips on this route on {date}.',
  'DEEP_LINKS.TRIP_ANALYZER.VEHICLE_OTHER_DIRECTION': 'Vehicle {value} also ran {count} trips going {direction}.',
  'DEEP_LINKS.TRIP_ANALYZER.VEHICLE_OTHER_DIRECTION_ONE': 'Vehicle {value} also ran 1 trip going {direction}.',
  'DEEP_LINKS.TRIP_ANALYZER.VEHICLE_AMBIGUOUS': 'Vehicle {value} matches {matches} on this route on {date}. Pick a direction and trips.',
  'DEEP_LINKS.TRIP_ANALYZER.VEHICLE_LOAD_FAILED': 'Couldn’t load vehicle {value}’s trips. Refresh the page to try again.',
  'DEEP_LINKS.TRIP_ANALYZER.SHOW_OTHER_DIRECTION': 'Show them',
  'DEEP_LINKS.DISMISS': 'Dismiss',
  'DEEP_LINKS.TRIP_ANALYZER.OPENING': 'Opening link…',
  'DEEP_LINKS.TRIP_ANALYZER.STEP_DATES': 'Loading service dates',
  'DEEP_LINKS.TRIP_ANALYZER.STEP_ROUTES': 'Loading routes for {date}',
  'DEEP_LINKS.TRIP_ANALYZER.STEP_DIRECTIONS': 'Loading directions',
  'DEEP_LINKS.TRIP_ANALYZER.STEP_VEHICLE': 'Finding vehicle {value}’s trips',
  'DEEP_LINKS.TRIP_ANALYZER.STEP_TRIPS': 'Loading trips',
  'DEEP_LINKS.TRIP_ANALYZER.STEP_TIMELINE': 'Loading the timeline',
  'DEEP_LINKS.TRIP_ANALYZER.DIRECTION_NOT_FOUND': 'That direction has no trips on {date}.',
  'DEEP_LINKS.TRIP_ANALYZER.TRIPS_NOT_FOUND': 'The linked trip isn’t here on {date}. Showing all trips.',
  'DEEP_LINKS.TRIP_ANALYZER.TRIP_SET_NOT_FOUND': 'Some trip set trips aren’t on this route on {date}, so they were left out.',
  'DEEP_LINKS.LIVE.ROUTES_NOT_FOUND': 'These routes aren’t on the live map: {routes}.',
  'DEEP_LINKS.LIVE.ENTITY_NOT_FOUND': '{entity} {id} isn’t on the live map right now.',
  'DEEP_LINKS.LIVE.ENTITY_VEHICLE': 'Vehicle',
  'DEEP_LINKS.LIVE.ENTITY_SIGNAL': 'Signal',
  'DEEP_LINKS.LIVE.ENTITY_EMERGENCY_VEHICLE': 'Emergency vehicle',
  'DEEP_LINKS.LIVE.ENTITY_INCIDENT': 'Incident',
  'DEEP_LINKS.LIVE.ENTITY_BUS': 'Bus',
  'DEEP_LINKS.LIVE.ENTITY_TRAIN': 'Train',
  'DEEP_LINKS.LIVE.HEADER_CLOSE': 'Close details',
  'DEEP_LINKS.LIVE.HEADER_BACK': 'Back to the previous selection',
  'DEEP_LINKS.ANALYZE_TOOLTIP': 'Analyze this vehicle’s trips from yesterday in Trip Analyzer',
  'DEEP_LINKS.VEHICLE_NOW': 'Where is vehicle {id} now? Open it on the live map',
  'DEEP_LINKS.SIGNAL_LIVE': 'Show this signal’s live status on the map',
  'DEEP_LINKS.ANALYZE_TRIPS': 'Analyze trips',
  'DEEP_LINKS.WORST_DAY': 'Worst day: {date}',
  'DEEP_LINKS.DAY_HINT': 'Click a day to analyze its trips',
  'DEEP_LINKS.DAY_VS_AVERAGE': '{delta} vs. the period average',
  'DEEP_LINKS.INVALID_PARAM': 'Part of this link couldn’t be read ({param}).',
  'DEEP_LINKS.TRIP_TRACER.OPENING': 'Opening link…',
  'DEEP_LINKS.TRIP_TRACER.DATE_NO_DATA': 'No vehicle history on {date}. Pick another date.',
  'DEEP_LINKS.TRIP_TRACER.VEHICLE_NOT_FOUND': 'Vehicle {value} has no history on {date}. Pick another vehicle.',
  'DEEP_LINKS.TRIP_TRACER.ROUTE_NOT_FOUND': 'Route {value} has no vehicle history on {date}. Pick another route.',
  'DEEP_LINKS.TRIP_TRACER.VEHICLE_AMBIGUOUS': 'Vehicle {value} matches {matches} on {date}. Pick one.',
  'DEEP_LINKS.REPLAY_TRIP': 'Replay this trip in Trip Tracer',
  'DEEP_LINKS.REPLAY_TODAY': 'Replay today',
  'DEEP_LINKS.REPLAY_TODAY_TOOLTIP': 'Replay this vehicle’s day so far in Trip Tracer',
  'DEEP_LINKS.ANALYZE_TRIP': 'Analyze this vehicle’s trips on this route in Trip Analyzer',
};
